import { Box, Text, Link, Flex, forwardRef } from '@chakra-ui/react';

import ArrowIcon from '@/assets/icons/ic-arrow-tilted.svg';

interface ILinkReferenceProps {
  title: string;
  url: string;
}

export const LinkReference = forwardRef<ILinkReferenceProps, 'a'>(function LinkReference({ title, url }, ref) {
  return (
    <Box
      as={Link}
      target="_blank"
      href={url}
      mb={6}
      display="block"
      sx={{
        svg: {
          display: 'none',
        },
      }}
      _hover={{
        textDecoration: 'none',
        color: 'violet.500',
        svg: {
          display: 'inline',
        },
      }}
      ref={ref}
    >
      <Text as={Flex} mb={2} fontSize="xl" lineHeight={6} fontWeight="semibold" fontFamily="underline">
        {title}
        <ArrowIcon width="24px" height="24px" />
      </Text>
      <Text fontSize="sm" lineHeight="shorter" color="gray.700">
        {url}
      </Text>
    </Box>
  );
});
